import React from "react";
import { Space, Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;

/**
 * Renders a single user option in the MultiSelectPeoplePicker dropdown.
 * The checkmark for selection is automatically handled by the parent Ant Design Select component.
 */
export default function PeoplePickerList({ option }) {
  return (
    <Space direction="vertical" style={{ gap: 0 }}>
      <Text strong>{option.name} - {option.system_id}</Text>
      <Text type="secondary">{option.email_id} - {option.job_title || "N/A"}</Text>
    </Space>
  );
}

PeoplePickerList.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string,
    system_id: PropTypes.string,
    email_id: PropTypes.string,
    job_title: PropTypes.string,
  }).isRequired,
};
